import React from 'react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

interface SubmitInfoProps {
  key1: string;
  key2: string;
  key3?: string;
}

const SubmitInfo: React.FC<SubmitInfoProps> = ({ key1, key2, key3 }) => {
  const { t } = useTranslation();

  return (
    <div className="submit-info">
      {t(key1)}
      <strong className="green">{t('link_download')}</strong>
      {t(key2)}{' '}
      <Link href="/terminal/privacy-policy" passHref>
        <span>{t('link_privacyPolicy_1')}</span>
      </Link>
      {key3 && <div className="accent">{t(key3)}</div>}
    </div>
  );
};

export default SubmitInfo;
